module.exports = __webpack_public_path__ + "8f84210a1b8255846f73190324d10d4f.png";